export const pushDiscountName = (name: string): void => {
  window?.dataLayer?.push({ 'discount_name': name });
};
